import _asyncToGenerator from "/Users/samlee/Documents/GitHub/samanthallee.github.io/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "/Users/samlee/Documents/GitHub/samanthallee.github.io/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/Users/samlee/Documents/GitHub/samanthallee.github.io/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/samlee/Documents/GitHub/samanthallee.github.io/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/samlee/Documents/GitHub/samanthallee.github.io/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/samlee/Documents/GitHub/samanthallee.github.io/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/samlee/Documents/GitHub/samanthallee.github.io/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/Users/samlee/Documents/GitHub/samanthallee.github.io/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { ExternalInteractorBase } from "tsparticles-engine";
import { Push } from "./Options/Classes/Push";
import { itemFromArray } from "tsparticles-engine";
export var Pusher = /*#__PURE__*/function (_ExternalInteractorBa) {
  _inherits(Pusher, _ExternalInteractorBa);

  var _super = _createSuper(Pusher);

  function Pusher(container) {
    var _this;

    _classCallCheck(this, Pusher);

    _this = _super.call(this, container);

    _this.handleClickMode = function (mode) {
      if (mode !== "push") {
        return;
      }

      var container = _this.container,
          options = container.actualOptions,
          pushOptions = options.interactivity.modes.push;

      if (!pushOptions) {
        return;
      }

      var pushNb = pushOptions.quantity;

      if (pushNb <= 0) {
        return;
      }

      var group = itemFromArray([undefined].concat(_toConsumableArray(pushOptions.groups))),
          groupOptions = group !== undefined ? container.actualOptions.particles.groups[group] : undefined;
      container.particles.push(pushNb, container.interactivity.mouse, groupOptions, group);
    };

    return _this;
  }

  _createClass(Pusher, [{
    key: "clear",
    value: function clear() {}
  }, {
    key: "init",
    value: function init() {}
  }, {
    key: "interact",
    value: function () {
      var _interact = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function interact() {
        return _interact.apply(this, arguments);
      }

      return interact;
    }()
  }, {
    key: "isEnabled",
    value: function isEnabled() {
      return true;
    }
  }, {
    key: "loadModeOptions",
    value: function loadModeOptions(options) {
      if (!options.push) {
        options.push = new Push();
      }

      for (var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        sources[_key - 1] = arguments[_key];
      }

      for (var _i = 0, _sources = sources; _i < _sources.length; _i++) {
        var source = _sources[_i];
        options.push.load(source === null || source === void 0 ? void 0 : source.push);
      }
    }
  }, {
    key: "reset",
    value: function reset() {}
  }]);

  return Pusher;
}(ExternalInteractorBase);